import { render, staticRenderFns } from "./editorallot.vue?vue&type=template&id=2a90c1d8&scoped=true"
import script from "./editorallot.vue?vue&type=script&lang=js"
export * from "./editorallot.vue?vue&type=script&lang=js"
import style0 from "./editorallot.vue?vue&type=style&index=0&id=2a90c1d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a90c1d8",
  null
  
)

export default component.exports